import React, { startTransition } from "react";
import { Switch } from "@mantine/core";
import { DateTime } from "luxon";
import css from "./OrganizationHeader.module.scss";

const periods = [
  { value: 7, days: 7, label: "Week" },
  { value: 30, days: 28, label: "Month" },
  { value: 90, days: 91, label: "Quarter" },
];

export function organizationDateRange(snapshotDate, duration) {
  const period = periods.find((item) => item.value === duration) || periods[0];
  const snapshot = DateTime.fromFormat(snapshotDate || "", "M-d-yyyy");
  if (!snapshot.isValid) return `Last ${period.days} days`;
  const start = snapshot.minus({ days: period.days });
  const end = snapshot.minus({ days: 1 });
  const format = start.year !== end.year ? "d LLL yyyy" : "d LLL";
  return `Last ${period.days} days · ${start.toFormat(format)} – ${end.toFormat(format)}`;
}

export default function OrganizationHeader({
  title = "Organization",
  snapshotDate,
  duration,
  onDurationChange,
  includeSelf,
  onIncludeSelfChange,
}) {
  return (
    <header className={css.header}>
      <div>
        <h1>{title}</h1>
        <p aria-live="polite">
          {organizationDateRange(snapshotDate, duration)}
        </p>
      </div>
      <div className={css.filters}>
        <div className={css.periods} role="group" aria-label="Reporting period">
          {periods.map((period) => (
            <button
              key={period.value}
              type="button"
              aria-pressed={duration === period.value}
              onClick={() =>
                startTransition(() => onDurationChange(period.value))
              }
            >
              {period.label}
            </button>
          ))}
        </div>
        {onIncludeSelfChange && (
          <Switch
            color="dark"
            label="Include me"
            checked={includeSelf}
            onChange={onIncludeSelfChange}
            size="xs"
            styles={{
              track: {
                backgroundColor: includeSelf ? "#202231" : "#d5d8df",
                borderColor: includeSelf ? "#202231" : "#d5d8df",
                cursor: "pointer",
              },
              label: {
                fontSize: 13,
                fontWeight: 500,
                color: "#43465a",
                cursor: "pointer",
              },
            }}
          />
        )}
      </div>
    </header>
  );
}
